module.exports = __webpack_public_path__ + "images/icon/search_navy_16-be587035.svg";